import { startTools } from "./start-tools.js";

/**
 * The entry point for the conversion tools.
 *
 * All of it. The bundle is loaded by the tool layout with `type="module"`,
 * which is deferred by definition, so there is nothing to wait for: the markup
 * this drives has already been parsed by the time it runs.
 *
 * It exports nothing, and that is the point — a module whose whole purpose is
 * a side effect should not also be something other modules import.
 */
startTools(document);
